import { Grid, Stack } from "@mui/material";
import { AddressFields, FormikTextField } from "@shared";
import { FormikProps } from "formik";

import { FormikAutocomplete } from "@/common/components/fields/formik/formik-autocomplete/FormikAutocomplete";
import { DropdownOptions } from "@/common/hooks/useDropdownOptions";
import { useTranslation } from "@/translations";

import { VolunteerFormType, VolunteerMaxLength } from "./VolunteerForm.types";

interface Props {
  formik: FormikProps<VolunteerFormType>;
  dropdownOptions: DropdownOptions;
}

export function VolunteerFormFields({ formik, dropdownOptions }: Props) {
  const { t } = useTranslation();

  return (
    <Stack pt={2} gap={3}>
      <Grid container rowSpacing={2} columnSpacing={2}>
        <Grid size={6}>
          <FormikAutocomplete
            formik={formik}
            fieldName="salutation"
            label={t("volunteers.form.salutation")}
            options={dropdownOptions.salutations}
          />
        </Grid>
        <Grid size={6}>
          <FormikTextField
            formik={formik}
            fieldName="title"
            label={t("volunteers.form.title")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.title } } }}
          />
        </Grid>

        <Grid size={4}>
          <FormikTextField
            formik={formik}
            fieldName="firstName"
            label={t("volunteers.form.firstName")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.firstName } } }}
            required
          />
        </Grid>
        <Grid size={4}>
          <FormikTextField
            formik={formik}
            fieldName="lastName"
            label={t("volunteers.form.lastName")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.lastName } } }}
            required
          />
        </Grid>
        <Grid size={4}>
          <FormikTextField
            formik={formik}
            fieldName="username"
            label={t("volunteers.form.username")}
            helperText={t("volunteers.form.usernameHelper")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.username } } }}
            required
          />
        </Grid>

        {/* Straße with Wiener-Adressregister autocomplete; picking a suggestion pre-fills
            Hausnummer/PLZ/Ort and sets Land to Österreich. */}
        <AddressFields
          formik={formik}
          streetField="street"
          houseNumberField="houseNumber"
          zipCodeField="zipCode"
          cityField="city"
          countryField="country"
          required={{ street: true, houseNumber: true, zipCode: true, city: true, country: true }}
        />

        <Grid size={6}>
          <FormikTextField
            formik={formik}
            fieldName="email"
            label={t("volunteers.form.email")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.email } } }}
            required
          />
        </Grid>
        <Grid size={6}>
          <FormikTextField
            formik={formik}
            fieldName="phone"
            label={t("volunteers.form.phone")}
            slotProps={{ input: { inputProps: { maxLength: VolunteerMaxLength.phone } } }}
          />
        </Grid>

        <Grid size={12}>
          <FormikTextField
            formik={formik}
            fieldName="remarks"
            label={t("volunteers.form.remarks")}
            multiline
            minRows={4}
          />
        </Grid>
      </Grid>
    </Stack>
  );
}
